import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import Page from '../../components/Page';
import Loader from '../../components/Loader';
import { ErrorFlash } from '../../components/Flash';
import { classes } from '../../components/Button';
import { ProfileContext, ProfileManager } from '../../profile';
import { useRequest, getHeaders } from '../../api/client';
import ProductVariantsList from '../../components/ProductVariantsList';

const variants = (id: string, context: ProfileManager) => {
  const [state, _] = useRequest(() => ({
    url: `/store/products/${id}/variants`,
    method: 'GET',
    headers: getHeaders(context),
  }));

  return state;
};

// const newProduct = (): any => ({
//   available: true,
//   available_from: null,
//   available_in: [],
//   available_worldwide: true,
//   categories: [],
//   category_ids: [],
//   company_id: null,
//   description_text: '',
//   details: [],
//   id: null,
//   image_url: null,
//   images: [],
//   name: '',
//   public_url: null,
//   tags: [],
//   theme: null,
//   variants: [],
// });

export default function ProductVariants(props: RouteComponentProps<any>) {
  const productId = props.match.params.productId;
  const context = React.useContext(ProfileContext);
  const state = variants(productId, context);

  if (state.loading) {
    return <Loader />;
  }

  return (
    <Page
      title="Buying Options"
      subtitle="Manage sizes, colour configuration and pricing"
    >
      {state.error && <ErrorFlash error={state.error} />}
      <div className="flex justify-center ml-auto mr-auto">
        <Link
          to={{
            pathname: `/products/${productId}/variants/new`,
            state: {
              product: null,
            },
          }}
          className={`${classes} dib ml-auto mr-auto`}
        >
          Create new
        </Link>
      </div>
      <ProductVariantsList items={state.data || []} />
    </Page>
  );
}
